<!-- StatusBar.vue -->
<template>
  <div class="status-bar" :style="{ backgroundColor: backgroundColor }">
    <div class="status-container">
      <v-icon :color="iconColor" :size="iconSize">{{ icon }}</v-icon>
      <p class="status-text">{{ statusText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusBar",
  props: {
    statusText: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String,
      default: "14px",
    },

  },
  computed: {
    icon() {
      const icons = {
        active: "mdi-check-circle-outline",
        inactive: "mdi-minus-circle-outline",
        upcoming: "mdi-clock-plus-outline",
        expired: "mdi-close-box-outline",
      };
      return icons[this.statusText] ?? "";
    },
    iconColor() {
      const colors = {
        active: "#4CAF50",
        inactive: "rgba(0, 0, 0, 0.54)",
        upcoming: "#E38700",
        expired: "#F44336",
      };
      return colors[this.statusText] ?? "rgba(0, 0, 0, 0.54)";
    },
    backgroundColor() {
      const colors = {
        active: "rgba(76, 175, 80, 0.10)",
        inactive: "rgba(119, 119, 118, 0.10)",
        upcoming: "rgba(255, 152, 0, 0.10)",
        expired: "rgba(244, 67, 54, 0.10)",
      };
      return colors[this.statusText] ?? "transparent";
    },
  },
};
</script>

<style scoped>
.status-bar {
  display: flex;
  align-items: center;
  /* width: 70px; */
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(164, 162, 161, 0.4);

}

.status-container {
  display: flex;
  padding: 6px 12px;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;

}

.status-text {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

p {
  margin: 0;
}
</style>
